import React from "react"
import { Search } from "react-feather"
import { Toast } from "react-weui"
import { get } from "lodash"

import GogleMap from './GoogleMap'
import Recommendations from './Recommendations'
import { productsByCity } from "../../../../../data.json"
import { cities } from "../../../../../data"
import config from '../../../../../config.app'

export default class ShowDestination extends React.Component {
  constructor(props) {
    super(props);
    this.mapcontainer = React.createRef();
  }

  render() {
    return (
      <React.Fragment>
        <div
          className="map-container"
          ref={this.mapcontainer}
        >
          <GogleMap
            originCoords={this.props.originCoords}
            destinationCoords={this.props.destinationCoords}
            city={this.props.city}
            fetchingCoords={this.props.fetchingCoords}
            cities={cities}
            googleMapURL={config.google_maps_api}
            loadingElement={<div style={{ height: `100%` }} />}
            //containerElement={<div style={{ height: `${this.mapcontainer.current ? this.mapcontainer.current.clientHeight : 0}px` }} />}
            containerElement={<div style={{ flexGrow: 2 }} />}
            mapElement={<div style={{ height: `100%` }} />}
            searchBox
          />
          {this.props.fetchingCoords ? <Toast icon="loading" show>Loading...</Toast> : ""}
          
          <div className="search-container inmap" 
            onClick={() => {
              this.props.push(`/catalogo/${this.props.city}/transportation?step=searchDestination`)
            }}
          >
            <div className="field" >
              <div className="white">
                <div className="text">查询目的地 ...</div>
                <div className="icon search">
                  <Search />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="recomended"
        >
          <p>流行地点</p>
          <p
            onClick={() => {
              this.props.push(`/catalogo/${this.props.city}/transportation?step=showRecomendation&selectRencButt=80ulgbfn21`)
            }}
          >
            {"查看更多地点 >"}
          </p>
        </div>

        <Recommendations
          products={productsByCity[this.props.city].filter(p => !(get(p, "relations.isShy", false)))}
          onClick={product => {
            this.props.setDestination({
              destinationCoords: [product.preciseLocation.latitude, product.preciseLocation.longitude],
              destinationAddress: product.chName
            })
            this.props.push(`/catalogo/${this.props.city}/transportation?step=showOrigin`)
          }}
        />
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/catalogo/transportation/components/ShowDestination.jsx